import resources from '../services/resourcePacks';
import courseRepo from "../services/courses";

export const NEW_RESOURCE_PACK_OVERLAY_TOGGLED = 'NEW_RESOURCE_PACK_OVERLAY_TOGGLED';
export const RESOURCES_PACK_FILES_ADDED        = 'RESOURCES_PACK_FILES_ADDED';
export const RESOURCES_PACK_REMOVE_FILE_TO_ADD = 'RESOURCES_PACK_REMOVE_FILE_TO_ADD';
export const RESOURCES_PACKS_REFRESHED         = 'RESOURCES_PACKS_REFRESHED';
export const SHOW_DELETE_RESOURCE_PACK_OVERLAY = 'SHOW_DELETE_RESOURCE_PACK_OVERLAY';
export const HIDE_DELETE_RESOURCE_PACK_OVERLAY = 'HIDE_DELETE_RESOURCE_PACK_OVERLAY';
export const SHOW_EDIT_RESOURCE_PACK_OVERLAY   = 'SHOW_EDIT_RESOURCE_PACK_OVERLAY';
export const HIDE_EDIT_RESOURCE_PACK_OVERLAY   = 'HIDE_EDIT_RESOURCE_PACK_OVERLAY';
export const UPDATE_RESOURCE_PACK_SEARCH_RESULTS = 'UPDATE_RESOURCE_PACK_SEARCH_RESULTS';

export function showEditPackOverlay(pack) {

    return {
        type: SHOW_EDIT_RESOURCE_PACK_OVERLAY,
        pack
    }
}

export function hideEditPackOverlay() {

    return {
        type: HIDE_EDIT_RESOURCE_PACK_OVERLAY
    }
}

export function deleteResourcePack(packId) {

    return (dispatch) => {

        function removeSuccess() {

            dispatch(hideDeletePackOverlay());
            dispatch(refreshResourcePacks());
        }

        resources.remove(packId)
            .then(removeSuccess);
    };
}

export function hideDeletePackOverlay() {

    return {
        type: HIDE_DELETE_RESOURCE_PACK_OVERLAY
    };
}

export function showDeletePackOverlay(pack) {

    return {
        type: SHOW_DELETE_RESOURCE_PACK_OVERLAY,
        pack
    };
}

export function refreshResourcePacks() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(resourcePacksRefreshed(response.data.data));
        }

        resources.getAll()
            .then(getSuccess);
    };
}

export function resourcePacksRefreshed(packs) {

    return {
        type: RESOURCES_PACKS_REFRESHED,
        packs
    };
}

export function removeFileToAdd(fileIndex) {

    return {
        type: RESOURCES_PACK_REMOVE_FILE_TO_ADD,
        fileIndex
    }
}

export function addFilesToList(files) {
    
    return {
        type: RESOURCES_PACK_FILES_ADDED,
        files
    }
}

export function toggleNewResourcePackOverlay() {

    return {
        type: NEW_RESOURCE_PACK_OVERLAY_TOGGLED
    };
}

function updateResourcePackSearchResults(searchResults){
    return {
        type: UPDATE_RESOURCE_PACK_SEARCH_RESULTS,
        searchResults
    }
}

export function searchPacks(searchTerm) {
    const params = {
        searchTerm: searchTerm
    }

    return dispatch => {
        function getSuccess(response){
            dispatch(updateResourcePackSearchResults(response.data.data));
        }

        courseRepo.searchResourcePacks(params)
            .then(getSuccess);
    }
}


// WEBPACK FOOTER //
// ./actions/resourcePackList.js